<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <section>
      <fieldset>
        <legend>
          {{ fields + "allIpRules" | translate }}
        </legend>
        <div class="row">
          <!-- model -->
          <div
            *ngIf="model.length > 0"
            class="tw-pt-5"
            json-formatter
            [json]="model"
            class="tw-text-left dir-ltr dark:tw-invert-[1]"
          ></div>
          <div
            *ngIf="model.length == 0"
            class="tw-text-center tw-text-gray-700 dark:tw-text-gray-200 tw-my-5 tw-text-xl tw-dir-rtl ltr:tw-dir-ltr"
          >
            {{ "common.empty" | translate }}
          </div>
        </div>
      </fieldset>
    </section>
  </div>
</app-page-body>
